let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("c6gxD"), load("3UR1K"), load("3b99S")]).then(() => parcelRequire('d58Kh'));